


















import Vue from 'vue'

export default Vue.extend({
  name: 'SleekFilterInput',

  props: {
    showSmallText: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: 'Enter text...',
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      inputFocus: false,
    }
  },

  computed: {
    internalValue: {
      get(): any {
        return this.value
      },
      set(newValue: any) {
        this.$emit('input', newValue)
      },
    },
  },

  methods: {
    clearValue() {
      this.internalValue = ''
    },
    focusInput() {
      // @ts-ignore
      this.$refs.inputRef.focus()
    },
  },
})
